import type { HTMLAttributes } from "react";

type SkeletonShape = "text" | "media" | "control";

interface SkeletonProps extends HTMLAttributes<HTMLSpanElement> {
  shape?: SkeletonShape;
}

export function Skeleton({ className = "", shape = "text", ...props }: SkeletonProps) {
  return (
    <span
      aria-hidden="true"
      className={["skeleton", `skeleton--${shape}`, className].filter(Boolean).join(" ")}
      {...props}
    />
  );
}
